export const devices = {
  XS: 'xs',
  SM: 'sm',
  MD: 'md',
  LG: 'lg',
  XL: 'xl',
};

export const sizes = {
  xsMax: 575,
  sm: 576,
  smMax: 767,
  md: 768,
  mdMax: 991,
  lg: 992,
  lgMax: 1199,
  xl: 1200,
};

export const isDevice = (device) => {
  const width = $(window).width();
  const min = sizes[device];
  const max = sizes[`${device }Max`];

  if (!min && max) {
    return width <= max;
  } if (min && !max) {
    return width >= min;
  } if (min && max) {
    return width >= min && width <= max;
  }
  return false;
};

export const isBeforeOrEqualDevice = (device) => {
  const width = $(window).width();
  const min = sizes[device];
  const max = sizes[`${device }Max`];

  if (!max && min) {
    return true;
  } if (!max && !min) {
    return false;
  }
  return width <= max;
};
